import { Reducer } from 'redux'
import {
  ResellerActions,
  type ResellerAction,
  type ResellerState,
  initialResellerState,
} from './types'

export * from './types'

export const reducer: Reducer<ResellerState, ResellerAction> = (
  state = initialResellerState,
  action
) => {
  switch (action.type) {
    case ResellerActions.SET_RESELLERS_DATA: {
      return { ...state, resellers: action.payload }
    }
    default: {
      return state
    }
  }
}
